/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Information_ReceivedInputs */

const tr_geliver_substatus_information_received = /** @type {(inputs: Geliver_Substatus_Information_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilgi Alındı`)
};

const en_geliver_substatus_information_received = /** @type {(inputs: Geliver_Substatus_Information_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information Received`)
};

const de_geliver_substatus_information_received = /** @type {(inputs: Geliver_Substatus_Information_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information erhalten`)
};

const ru_geliver_substatus_information_received = /** @type {(inputs: Geliver_Substatus_Information_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информация получена`)
};

/**
* | output |
* | --- |
* | "Information Received" |
*
* @param {Geliver_Substatus_Information_ReceivedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_information_received = /** @type {((inputs?: Geliver_Substatus_Information_ReceivedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Information_ReceivedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_information_received(inputs)
	if (locale === "de") return de_geliver_substatus_information_received(inputs)
	if (locale === "ru") return ru_geliver_substatus_information_received(inputs)
	return tr_geliver_substatus_information_received(inputs)
});